import React, { useState } from "react";
import classNames from "./style.module.css";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

const topButtonsValues = [
  { text: "BASIN BÜLTENİ", value: 0 },
  { text: "DERECE ALAN OKULLAR", value: 1 },
  { text: "FOTOĞRAF GALERİSİ", value: 2 },
  // { text: "AKTİF YARIŞMALAR", value: 3 },
];

export default () => {
  const [selectedMenu, setSelectedMenu] = useState(0);
  const topButtons = (
    <ButtonGroup
      size="large"
      color="secondary"
      aria-label="large outlined primary button group"
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "8px",
        padding: "10px"
      }}
    >
      {topButtonsValues.map((b) => {
        return (
          <Button
            onClick={() => setSelectedMenu(b.value)}
            key={b.value + "topButton"}
            style={{ 
              color: "white", 
              fontWeight: 200,
              fontSize: window.innerWidth < 768 ? "14px" : "16px",
              padding: window.innerWidth < 768 ? "8px 12px" : "12px 24px",
              whiteSpace: "nowrap"
            }}
          >
            {b.text}
          </Button>
        );
      })}
    </ButtonGroup>
  );

  return (
    <div className={classNames.pageContainer}>
      {topButtons}
      {selectedMenu === 0 && <Bulten />}
      {selectedMenu === 1 && <MedahallOfFame />}
      {selectedMenu === 2 && <PhotoGallery />}
      {/* {selectedMenu === 3 && <ActiveCompetitions />} */}
    </div>
  );
};

const MedahallOfFame = () => {
  const generateMedal = ({
    medalType,
    schoolLogoPath,
    schoolName,
    studentList,
    tutorList,
  }) => {
    const silverMedal = (
      <img src="/assets/images/medals/silver.png" alt="silver" />
    );
    const goldMedal = <img src="/assets/images/medals/gold.png" alt="gold" />;
    const bronzeMedal = (
      <img src="/assets/images/medals/bronze.png" alt="bronze" />
    );

    const medalImage =
      medalType === "gold"
        ? goldMedal
        : medalType === "silver"
        ? silverMedal
        : bronzeMedal;

    const schoolLogoImage = (
      <div>
        <img
          src={schoolLogoPath ? schoolLogoPath : "/assets/images/meb-logo.png"}
          alt="home-logo"
          width="120"
          height="120"
        />
      </div>
    );

    const schoolNameSpan = (
      <div
        style={{
          marginTop: 30,
          fontSize: "24px",
          fontWeight: "bolder",
          color: "#15273A",
        }}
      >
        {toTurkishTitleCase(schoolName)}
      </div>
    );

    const studentListBox = (
      <div style={{ marginTop: 15 }}>
        <div style={{ fontSize: "24px", color: "#E79121" }}>Takım</div>
        {studentList.map((s) => (
          <div style={{ fontSize: "20px", textTransform: "capitalize" }}>
            {toTurkishTitleCase(s)}
          </div>
        ))}
      </div>
    );

    const tutorListBox = (
      <div style={{ marginTop: 15 }}>
        <div style={{ fontSize: "24px", color: "#E79121" }}>
          Sorumlu Öğretmen
        </div>
        {tutorList.map((t) => (
          <div style={{ fontSize: "20px", textTransform: "capitalize" }}>
            {toTurkishTitleCase(t)}
          </div>
        ))}
      </div>
    );
    return (
      <div
        style={{
          borderRadius: "15px",
          position: "relative",
          width: 339,
          height: 633,
          textAlign: "center",
          lineHeight: 1.1,
          margin: 10,
        }}
      >
        {medalImage}
        <div
          style={{
            position: "absolute",
            top: 150,
            textAlign: "center",
            width: 338,
            paddingLeft: 27,
            paddingRight: 27,
          }}
        >
          {schoolLogoImage}
          {schoolNameSpan}
          {studentListBox}
          {tutorListBox}
        </div>
      </div>
    );
  };

  const generateMedalGroup = ({ groupName, groupItems }) => {
    const isMobile = window.innerWidth < 768; // Mobil kontrolü

    const styles = {
      display: "flex",
      alignItems: "center",
      justifyContent: isMobile ? "center" : "space-between",
      fontSize: isMobile ? "18px" : "42px",
      paddingBottom: 20,
      borderBottom: "solid #DA571A 2px",
      marginBottom: 20,
      lineHeight: 1,
    };

    const header = (
      <div style={styles}>
        <span style={{ color: "#DA571A", textAlign: "left" }}>
          Türkiye Finalleri Sonuçları
        </span>
        <span style={{ color: "#15273A", fontWeight: "bold", marginLeft: 30 }}>
          {groupName}
        </span>
      </div>
    );

    return (
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 15,
          padding: 20,
          maxWidth: 1200,
          margin: 20,
        }}
      >
        {header}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {groupItems}
        </div>
      </div>
    );
  };

  //BİRİNCİ SINIF
  const birinciSinifMedals = generateMedalGroup({
    groupName: "Birinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fvkv-logo.png?alt=media&token=52869b54-d5cb-481e-afe2-bf5738140eda",
        schoolName: "VEHBİ KOÇ VAKFI KOÇ ÖZEL İLKOKULU",
        studentList: ["Veli Güler", "Hasan Oğuz Kuz", "Aras Birekul"],
        tutorList: ["Mehmet Çelik"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ffatih_logo.jpg?alt=media&token=afd36bca-7438-4e76-bbc6-d5b208a343ec",
        schoolName: "FATİH İLKOKULU",
        studentList: ["Mete Erel", "Gökçe Özkan", "Timur Batu Karakaya"],
        tutorList: ["İlyas Erel"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath: "",
        schoolName: "18 MART İLKOKULU",
        studentList: [
          "Gökçe Ada Çobanoğlu",
          "Asil Ertuğ Coşkun",
          "Hüseyin Uygar Demir",
        ],
        tutorList: ["Hüsna Asya Çobanoğlu"],
      }),
    ],
  });

  //İKİNCİ SINIF
  const ikinciSinifMedals = generateMedalGroup({
    groupName: "İkinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ffatih_logo.jpg?alt=media&token=afd36bca-7438-4e76-bbc6-d5b208a343ec",
        schoolName: "FATİH İLKOKULU",
        studentList: ["İshak Susar", "Deniz Efe Güngörür", "Selman Bat"],
        tutorList: ["İlyas Erel"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ftekden-logo.jpg?alt=media&token=6021b644-40a7-48cd-ada1-fe69781882f5",
        schoolName: "ÖZEL KAYSERİ TEKDEN İLKOKULU",
        studentList: ["Almina Defne Göç", "Ömer Asaf Kılıç", "Yiğit Özer"],
        tutorList: ["Tuba Baykal"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fkartal_bilsem.jpeg?alt=media&token=a07f0db9-5ecf-437b-8eaf-8546474c4b3b",
        schoolName: "KARTAL BİLİM VE SANAT MERKEZİ",
        studentList: ["Ertuğrul Büyükarmutçu", "Ares Mehmet Keleş", "Mert Bal"],
        tutorList: ["Umut Bektaş"],
      }),
    ],
  });

  //ÜÇÜNCÜ SINIF
  const ucuncuSinifMedals = generateMedalGroup({
    groupName: "Üçüncü Sınıf",

    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath: "",
        schoolName: "CUMHURİYET İLKOKULU",
        studentList: ["Mustafa Arden Mumcu", "Göktuğ Elmaz ", "Toprak Şahin"],
        tutorList: ["Gürhan Bayrak"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath: "",
        schoolName: "SAFRANBOLU BİLİM VE SANAT MERKEZİ",
        studentList: ["Necdet Çınar Çelik", "Elif Karaarslan"],
        tutorList: ["Murat Beşel"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ffsbsm-logo.jpg?alt=media&token=12bcf9d6-cb42-4d44-8787-557ed128ac44",
        schoolName: "İSTANBUL FUAT SEZGİN BİLİM VE SANAT MERKEZİ",
        studentList: ["Efe Günay", "Ali Koç", "Uzay Uylukçuoğlu"],
        tutorList: ["Berna Bengül Bursalıoğlu"],
      }),
    ],
  });

  ///DÖRDÜNCÜ SINIF
  const dorduncuSinifMedals = generateMedalGroup({
    groupName: "Dördüncü Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath: "",
        schoolName: "HAMZABEY BİLİM VE SANAT MERKEZİ",
        studentList: ["Yağız Şen", "Efe Berk Yağlıoğlu", "Beren Yenici"],
        tutorList: ["Cüneyt Yenipazar"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ffatih_logo.jpg?alt=media&token=afd36bca-7438-4e76-bbc6-d5b208a343ec",
        schoolName: "FATİH İLKOKULU",
        studentList: ["Emir Ege Arslanyörür", "Burak Saluç", "Kerem Tarım"],
        tutorList: ["İlyas Erel"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fulker_bilsem.png?alt=media&token=ba6831ff-0079-4728-b89b-d327e6b34097",
        schoolName: "ÜLKER YÖRÜKOĞLU BİLİM VE SANAT MERKEZİ",
        studentList: ["Kerim Enes Topuz", "Elif Asya Oruç", "Kerem Sönmez"],
        tutorList: ["Kadir Alper Çetin"],
      }),
    ],
  });

  //// BEŞİNCİ SINIF
  const besinciSinifMedals = generateMedalGroup({
    groupName: "Beşinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fbilfen-kurtk%C3%B6y-oo-logo.png?alt=media&token=079455e3-11d9-454e-ab3d-c7934c4dc73a",
        schoolName: "ÖZEL BİLFEN KURTKÖY ORTAOKULU",
        studentList: ["Mehmet Gündoğan", "Dora Engin", "Efe Öztürk"],
        tutorList: ["Alev Çeşit"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fadanabilsem-logo.png?alt=media&token=aa5ca064-22ae-47cc-9c1b-2679eb97c80d",
        schoolName: "ADANA BİLİM VE SANAT MERKEZİ",
        studentList: ["Mustafa Sarı", "Alp Menekşe", "Miraç Utku Girgin"],
        tutorList: ["Dilşad Ergen  "],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fargem-oo-logo.jpg?alt=media&token=56c12bfd-88a8-45a8-9e71-8334fb18a645",
        schoolName: "ARAŞTIRMA GELİŞTİRME EĞİTİM VE UYGULAMA MERKEZİ ORTAOKULU",
        studentList: [
          "Zeynep Elif Altınkeser",
          "Mert Kerim Durusoy",
          "Aras Efe",
        ],
        tutorList: ["Asuman Akdemir Tirsi"],
      }),
    ],
  });

  //ALTINCI SINIF
  const altinciSinifMedals = generateMedalGroup({
    groupName: "Altıncı Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fbahcesehir-logo.png?alt=media&token=99056b35-d31a-4776-b094-64679bab8b11",
        schoolName: "ÖZEL AYDIN BAHÇEŞEHİR ORTAOKULU",
        studentList: ["Can Rüzgar Sarıoğlu", "Demir Uyaroğlu", "Emre Kuru"],
        tutorList: ["Banu Çiftçi"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fargem-oo-logo.jpg?alt=media&token=56c12bfd-88a8-45a8-9e71-8334fb18a645",
        schoolName: "ARAŞTIRMA GELİŞTİRME EĞİTİM VE UYGULAMA MERKEZİ ORTAOKULU",
        studentList: ["Eyüp Bülbül", "Hasan Yiğit Acar", "Mustafa Yağız Şahin"],
        tutorList: [""],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fg%C3%B6lc%C3%BCk-bilsem.jpg?alt=media&token=dd7f4b3d-5b00-4a67-ac73-5be1538c2f20",
        schoolName: "GÖLCÜK BİLİM VE SANAT MERKEZİ",
        studentList: ["Çınar Yalçınkayalı", "İsmail Kemal İvgin", "Asaf Atak"],
        tutorList: ["Meryem Topal"],
      }),
    ],
  });

  //YEDİNCİ SINIF
  const yedinciSinifMedals = generateMedalGroup({
    groupName: "Yedinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fbahcesehir-logo.png?alt=media&token=99056b35-d31a-4776-b094-64679bab8b11",
        schoolName: "ÖZEL KARŞIYAKA BAHÇEŞEHİR KOLEJİ",
        studentList: ["Yağız Aydın", "Nehir Boz", "Suat Arhan Akçay"],
        tutorList: ["Burcu Kocamaz"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fkartal_bilsem.jpeg?alt=media&token=a07f0db9-5ecf-437b-8eaf-8546474c4b3b",
        schoolName: "KARTAL BİLİM VE SANAT MERKEZİ",
        studentList: ["Işıl Sürmeli", "Yusuf Numan Keskin", "Eymen Karayavuz"],
        tutorList: ["Umut Bektaş"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fadanabilsem-logo.png?alt=media&token=aa5ca064-22ae-47cc-9c1b-2679eb97c80d",
        schoolName: "ADANA BİLİM VE SANAT MERKEZİ",
        studentList: ["Rıfkı Emir Yalçın", "Jan Demircan", "Göktuğ Kuru"],
        tutorList: ["Hürü İpek"],
      }),
    ],
  });

  //SEKİZİNCİ SINIF
  const sekizinciSinifMedals = generateMedalGroup({
    groupName: "Sekizinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath: "",
        schoolName: "DARICA DENİZ YILDIZLARI ORTAOKULU",
        studentList: ["Berra Nur Bektaş", "Irmak Ören", "Mustafa Çiftçi"],
        tutorList: ["Yaşar Peren Yörük"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fanabilim-logo.png?alt=media&token=837162c4-00d7-433f-85c8-79f4652bf427",
        schoolName: "ÖZEL MALTEPE ANABİLİM ORTAOKULU",
        studentList: [
          "Okyanus Ege Pamuk",
          "Mahmut Efe Micozkadıoğlu",
          "Toprak Şen",
        ],
        tutorList: ["Ali Avcı"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fdenizlikoleji.jpg?alt=media&token=7ec79ff7-9e15-4952-baaa-c43603b8f878",
        schoolName: "ÖZEL DENİZLİ KOLEJİ ORTAOKULU",
        studentList: ["Azra Kavakoğlu", "Naciye Dinçer", "Cemre Nur Armağan"],
        tutorList: ["Fatih Kamer Anda"],
      }),
    ],
  });

  //DOKUZUNCU SINIF
  const dokuzuncuSinifMedals = generateMedalGroup({
    groupName: "Dokuzuncu Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath: "",
        schoolName: "MERKEZEFENDİ BELEDİYESİ ANADOLU İMAM HATİP LİSESİ",
        studentList: [
          "Muhammet Tayyip Yüksel",
          "Ahmet Kerem Akşit",
          "Hüseyin Eymen Karakurt",
        ],
        tutorList: ["Mukadder Kafalı"],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fatakumbilsem.jpg?alt=media&token=00a6532b-5a8d-47cb-949d-d4b87d6e0ec0",
        schoolName: "ATAKUM BİLİM VE SANAT MERKEZİ",
        studentList: [
          "Boran Yelekin",
          "Lena Sarin Şahan",
          "Ömer Faruk Güngörsün",
        ],
        tutorList: ["Esra İnan"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fselcuklu_bilsem.jpeg?alt=media&token=326ae89c-c8ee-4eef-bdb6-12db48cf8a08",
        schoolName: "SELÇUKLU BİLİM VE SANAT MERKEZİ",
        studentList: [
          "Mustafa Renas Bayhan",
          "Talha Esat Aksoy",
          "Necati Barış Tosun",
        ],
        tutorList: ["Çağrı Kemal Erdal"],
      }),
    ],
  });

  //ONUNCU SINIF
  const onuncuSinifMedals = generateMedalGroup({
    groupName: "Onuncu Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fargem-oo-logo.jpg?alt=media&token=56c12bfd-88a8-45a8-9e71-8334fb18a645",
        schoolName: "ARAŞTIRMA GELİŞTİRME EĞİTİM VE UYGULAMA MERKEZİ LİSESİ",
        studentList: ["Egemen Ertuğ", "Yiğit Baran Durmuş", "Yağız Efe Uzun"],
        tutorList: ["Fikret Çelenk  "],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath: "",
        schoolName: "YÜKSEL-İLHAN ALANYALI FEN LİSESİ",
        studentList: ["Sevi Masal Kabataş", "Ecem Soylu", "Ahmet Onur Akış"],
        tutorList: ["Mahmut Yavuz"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fnil%C3%BCferborsa.png?alt=media&token=3aa85d2e-6560-46ad-bab0-e1eb739b70ad",
        schoolName: "NİLÜFER BORSA İSTANBUL FEN LİSESİ",
        studentList: ["Zeren Çöler ", "Yağız Gülmez", "Ali Ada Sertel"],
        tutorList: ["İpek Teymuroğlu"],
      }),
    ],
  });

  //ONBİRİNCİ SINIF
  const onbirinciSinifMedals = generateMedalGroup({
    groupName: "On Birinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ft%C3%BCbitak_fl.jpeg?alt=media&token=e1538dc5-df41-4407-be98-130d82995918",
        schoolName: "TÜBİTAK FEN LİSESİ",
        studentList: [
          "Selman Ergin",
          "Kadir Kağan Şahin ",
          "Hüseyin Buğra Dündar  ",
        ],
        tutorList: ["Mehmet Bilgi  "],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath: "",
        schoolName: "KADIKÖY BİLİM VE SANAT MERKEZİ",
        studentList: ["Mine Türköz", "Açelya İris Kaya", "Recep Arda Kaptan"],
        tutorList: ["Yudum Özer"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fistanbul_el.jpeg?alt=media&token=9e432220-e365-4e01-b20f-ddc24c0e9784",
        schoolName: "İSTANBUL ERKEK LİSESİ",
        studentList: [
          "Barış Nişancı",
          "Sare Nihan Yeşilırmak",
          "Yusuf Ozan Aydın",
        ],
        tutorList: ["Murat Yoğurtçu"],
      }),
    ],
  });

  //ONİKİNCİ SINIF
  const onikinciSinifMedals = generateMedalGroup({
    groupName: "On İkinci Sınıf",
    groupItems: [
      generateMedal({
        medalType: "gold",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Ftev-logo.png?alt=media&token=41d1f45c-c162-4791-95c7-6ef678b2eb05",
        schoolName: "TÜRK EĞİTİM VAKFI ÖZEL İNANÇ TÜRKEŞ LİSESİ",
        studentList: [
          "Abdurrahman Cırık  ",
          "Deniz Devrilmez  ",
          "Onur Ilgaz Çelebi ",
        ],
        tutorList: ["Serkan Tazegül  "],
      }),
      generateMedal({
        medalType: "silver",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Faselsan-logo.jpg?alt=media&token=c9fd8ccd-51f5-4f2c-a2ac-30c612851edc",
        schoolName: "ASELSAN MESLEKİ VE TEKNİK ANADOLU LİSESİ",
        studentList: [
          "Mustafa Enes Duman",
          "Arif Hamit Kiraz",
          "Alaaddin Olğaç",
        ],
        tutorList: ["Dilek Manav Devirmiş"],
      }),
      generateMedal({
        medalType: "bronze",
        schoolLogoPath:
          "https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fderece_alan_okul_logolari%2Fkadikoy_bilsem.jpeg?alt=media&token=c35ccbbd-f461-4dcd-9caa-f600866b8b09",
        schoolName: "KADIKÖY BİLİM VE SANAT MERKEZİ",
        studentList: ["Bersu Berker  ", "Eymen Doğu Payla  "],
        tutorList: ["Yudum Özer"],
      }),
    ],
  });
  return (
    <div>
      {birinciSinifMedals}
      {ikinciSinifMedals}
      {ucuncuSinifMedals}
      {dorduncuSinifMedals}
      {besinciSinifMedals}
      {altinciSinifMedals}
      {yedinciSinifMedals}
      {sekizinciSinifMedals}
      {dokuzuncuSinifMedals}
      {onuncuSinifMedals}
      {onbirinciSinifMedals}
      {onikinciSinifMedals}
    </div>
  );
};

const PhotoGallery = () => {
  return (
    <div style={{ marginTop: "30px" }}>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://halici.pixieset.com/turkiyezekaoyunlarisampiyonasi20242025/"
      >
        <Button size="large" color="secondary" variant="contained">
          GALERİYE ULAŞMAK İÇİN TIKLAYINIZ
        </Button>
      </a>
    </div>
  );
};
const ActiveCompetitions = () => {
  return (
    <div className={"card "} style={{ marginTop: "30px", width: "100%", maxWidth: "600px", margin: "30px auto" }}>
      <img
        style={{
          width: "85%",
          marginBottom: "10px",
          justifyContent: "center",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "30px",
          borderRadius: "15px",
        }}
        src="assets\images\oyun2025_yatay.jpg"
        alt="Oyun 2025"
      ></img>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://oyun.tzv.org.tr/"
        style={{ display: "block", textAlign: "center" }}
      >
        <Button
          size="large"
          color="secondary"
          variant="contained"
          style={{ marginBottom: "10px", width: "90%", maxWidth: "400px" }}
          target="_blank"
        >
          YARIŞMA SAYFASINA ULAŞMAK İÇİN TIKLAYINIZ
        </Button>
      </a>
    </div>
  );
};
const Bulten = () => {
  return (
    <div
      className={"card " + classNames.long_description}
      // className={"card"}
      style={{ fontSize: "medium" }}
    >
      <h4 style={{ fontWeight: "bold", marginTop: 30, textAlign: "center" }}>
        Türkiye 6. Okullar Arası Zeka Oyunları Şampiyonası'nın Ödül Töreni MEB
        Şura Salonuna Gerçekleştirildi!
      </h4>
      <img
        style={{ width: "100%" }}
        src="https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fbulten_foto%2F%C3%B6d%C3%BCl_t%C3%B6reni.jpg?alt=media&token=f34f1346-6200-489d-9d9e-bd4c026e5abb"
        alt="ödül töreni fotoğrafı"
      ></img>
      <p></p>
      {/* <div
        className={"card " + classNames.sponsor_card}
        style={{ marginTop: 0 }}
      >
        <iframe
          width="560"
          maxWidth="100%"
          height="315"
          // maxHeight = "100%"
          src="https://www.youtube.com/embed/wX1SGCKw-qo"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div> */}
      <p>
        Türkiye Zeka Vakfının Millî Eğitim Bakanlığı ve TÜBİTAK'ın destekleriyle
        başlattığı, Türkiye İş Bankası'nın Ana Sponsorluğunu yaptığı "Türkiye 6.
        Okullar Arası Zeka Oyunları Şampiyonası"nın ödül töreni MEB Şura
        Salonu'nda gerçekleştirildi.
      </p>
      <p>
        Türkiye genelinde 12.898 öğrencinin katıldığı Türkiye 6. Okullar Arası
        Zeka Oyunları Şampiyonası'nın ödül töreninde birinci sınıftan on ikinci
        sınıfa kadar ilk üç dereceyi alan okullara ödülleri Türkiye Zeka Vakfı
        Başkanı Emrehan Halıcı, Türkiye İş Bankası Afet ve Olağanüstü Durum
        Koordinatörü Ünal Tolga Esgin, Millî Eğitim Bakanlığı Personel Genel
        Müdürü Bülent Çiftci, Millî Eğitim Bakanlığı Ölçme Değerlendirme ve
        Sınav Hizmetleri Genel Müdür Yardımcısı Umut Erkin Taş, Türkiye Zeka
        Vakfı Yönetim Kurulu Üyesi Prof. Dr. Özgül Yılmaz Tüzün ve Millî Eğitim
        Vakfı Başkanı Salih Çiftçi tarafından verildi.
      </p>

      <img
        style={{ width: "100%" }}
        src="https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fbulten_foto%2Fkonusmacilar.jpg?alt=media&token=c9c48be0-fe0a-4850-8172-6ddd87aba6a1"
        alt="konuşmacılar"
      ></img>
      <p></p>
      <p>
        Türkiye Zeka Vakfı Başkanı Emrehan Halıcı Şampiyona'ya destek veren
        kurumlara teşekkür etti ve şunları söyledi: "Günümüzde rekabet aldı
        başını gidiyor. Bireyler arasında, gruplar arasında, kurumlar arasında,
        devletler arasında acımasız, hatta vahşi bir rekabet var. Sonuca
        ulaşmak, üstünlük elde etmek için her yol mübah görülüyor, tüm değerler
        çiğnenebiliyor. Rekabet, gelişmeyi, ilerlemeyi, başarıyı tetikleyebilir;
        ama kıyasıya yapıldığında, iş birliği ve yardımlaşmadan doğacak ek
        avantajlara engel oluşturuyor. Sevgili öğrenciler, birbirinizle iletişim
        kurunuz, sevgi, saygı ve ahlak kuralları içinde birbirinizle yarışınız
        ama acımasız bir rekabet anlayışıyla asla hareket etmeyiniz. Birbirinizi
        rakip olarak değil, dünyamızı karartan güçlü rakiplere karşı birlikte
        mücadele edecek takım arkadaşları olarak görünüz. Bu güçlü rakipler
        dünyamızdaki savaşlar, açlıklar, yoksulluklar, çevre tahribatları ve
        benzer olumsuzluklardır. Birlikte hareket ederek, kafa kafaya, yürek
        yüreğe ve el ele vererek bizim çözemediğimiz bu problemlerin üstesinden
        gelmek ve dünyamızı daha iyi bir dünya haline getirmek için çaba sarf
        ediniz."
      </p>
      <p>
        Türkiye İş Bankası Afet ve Olağanüstü Durum Koordinatörü Ünal Tolga
        Esgin konuşmasında; zekânın sadece bir yetenek olmadığını, çalışmak,
        sabretmek ve ahlakla şekillendiğini söyledi. Esgin, "Zekâsını iyilik
        için kullanan bireyler hem başarılı hem de saygı duyulan insanlar
        olurlar. Buradaki her öğrencimiz, ailesi ve okulu için olduğu kadar
        ülkemiz için de çok kıymetlidir. Sizler Türkiye'nin yarınlarına yön
        verecek fikirlerin ve projelerin taşıyıcılarısınız," dedi.
      </p>

      <p>
        Millî Eğitim Bakanlığı Personel Genel Müdürü Bülent Çiftci,
        Şampiyona'nın sadece rekabetten ibaret olmadığını, düşünme disiplini,
        paylaşma bilinci, analitik düşünme becerisi ve dayanışma ruhu kazandıran
        önemli bir öğrenme süreci olduğunu vurguladı. Öğrencilere düşünmeyi ve
        öğrenmeyi sevmelerini, zekânın sadece test sonuçlarıyla değil; düşünme
        biçimi, davranışlardaki tutarlılık, paylaşma isteği ve sosyal hayattaki
        erdemlerle ölçüldüğünü hatırlattı.
      </p>
      <img
        style={{ width: "100%" }}
        src="https://firebasestorage.googleapis.com/v0/b/championship-meb.appspot.com/o/tozos_24_25%2Fbulten_foto%2Fkupa-teslimi.jpg?alt=media&token=dde6b4ec-1c13-4c34-830c-6c645db3a298"
        alt="kupa teslimi"
      ></img>
    </div>
  );
};

function toTurkishTitleCase(str) {
  return str
    .toLocaleLowerCase("tr-TR")
    .split(" ")
    .map((word) => word.charAt(0).toLocaleUpperCase("tr-TR") + word.slice(1))
    .join(" ");
}
